import React, { useEffect, useRef } from 'react';
import { StyledAlert, StyledDialog, StyledIconButton, StyledInner, StyledLayoutContainer } from '../index.styles.js';
import {} from '../index.js';
import { handleBackdropClick } from '../shared/handle-backdrop-click.js';
import { useFocusTrap } from '../../../utils/use-focus-trap.js';
import { pickDataProps } from '../../../utils/pick-data-props.js';
import { pickA11yProps } from '../../../utils/pick-a11y-props.js';
export const DialogNative = ({ children, padding = true, open, triggerButton, variant, dialogAriaProps, onCloseButtonAriaLabel, onCloseButtonClick, onClose, className, hasCloseButton, ...rest }) => {
    const ref = useRef(null);
    const triggerRef = useRef(null);
    // TODO: Remove handleClose and replace it with the onClose prop once onCloseButtonClick has been removed
    const handleClose = () => {
        if (onCloseButtonClick) {
            onCloseButtonClick();
        }
        if (onClose) {
            onClose();
        }
    };
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        const handleMouseDown = (event) => {
            handleBackdropClick({ event, onClose, ref });
        };
        element.addEventListener('cancel', handleClose);
        element.addEventListener('click', handleMouseDown);
        if (open) {
            element.showModal();
        }
        else {
            element.close();
        }
        return () => {
            element.removeEventListener('cancel', handleClose);
            element.removeEventListener('click', handleMouseDown);
        };
    }, [open, onClose]);
    useFocusTrap({
        open,
        ref,
        triggerRef
    });
    return (React.createElement(React.Fragment, null,
        triggerButton && React.cloneElement(triggerButton, { ref: triggerRef }),
        React.createElement(StyledDialog, { ...pickDataProps(rest), ...pickA11yProps(rest), ref: ref, "aria-describedby": dialogAriaProps?.ariaDescribedBy, "aria-labelledby": dialogAriaProps?.ariaLabelledBy, variant: variant, hasPadding: padding, className: className }, variant === 'alert' ? (React.createElement(StyledAlert, { hasPadding: padding }, children)) : (React.createElement(StyledLayoutContainer, null,
            hasCloseButton && (React.createElement(StyledIconButton, { "aria-label": onCloseButtonAriaLabel, variant: "tertiary", icon: "cancel", onClick: handleClose, size: "sm" })),
            React.createElement(StyledInner, { hasPadding: padding, variant: variant }, children))))));
};
//# sourceMappingURL=native.js.map